import './FileChooseButton.css'

export default function FileChooseButton({ fieldId, buttonText }) {
  console.log('FileChooseButton rendered')

  return (
    <label className="file-choose-button" htmlFor={fieldId}>{buttonText}</label>
  )
}
